import { URLS } from '../../env/urls';
import { sendServerRequest } from '../../server/request';
import {
  CreateEvolutionInstanceRequest,
  UpdateEvolutionInstanceRequest,
  EvolutionInstancesListResponse,
  EvolutionInstance,
  V8Login,
} from '../../types/admin';

// Monta a URL pública do webhook GLOBAL da Evolution (a mesma para todas as instâncias —
// a Evolution só aceita um webhook, com token fixo do servidor). `webhookPath` é a parte
// relativa devolvida pelo backend (/server/evolution/webhook/<token>); aqui prefixamos a
// origin em que o admin está servido (onde o backend /server/... responde).
export function buildEvolutionWebhookUrl(webhookPath?: string): string {
  if (!webhookPath) return '';
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}${webhookPath}`;
}

// API dedicada das instâncias Evolution (WhatsApp não-oficial, multi-número).
export const evolutionInstancesApi = {
  async create(data: CreateEvolutionInstanceRequest): Promise<EvolutionInstance> {
    const result = await sendServerRequest('POST', URLS.admin.accounts.evolution.create, data);
    return result.data.data;
  },

  async list(page: number = 0, limit: number = 20): Promise<EvolutionInstancesListResponse> {
    const url = `${URLS.admin.accounts.evolution.list}?page=${page}&limit=${limit}`;
    const result = await sendServerRequest('GET', url);
    // O backend responde { instances, total, page, limit, pages }.
    return result.data.data;
  },

  async getById(id: number): Promise<EvolutionInstance> {
    const url = URLS.admin.accounts.evolution.get(id);
    const result = await sendServerRequest('GET', url);
    return result.data.data.instance;
  },

  async update(id: number, data: UpdateEvolutionInstanceRequest): Promise<EvolutionInstance> {
    const url = URLS.admin.accounts.evolution.update(id);
    const result = await sendServerRequest('PUT', url, data);
    return result.data.data;
  },

  async delete(id: number): Promise<void> {
    const url = URLS.admin.accounts.evolution.delete(id);
    await sendServerRequest('DELETE', url);
  },

  async toggle(id: number): Promise<{ id: number; is_active: boolean }> {
    const url = URLS.admin.accounts.evolution.toggle(id);
    const result = await sendServerRequest('PATCH', url);
    return result.data.data;
  },

  // Testa a instância: o número conectado envia uma mensagem de teste para si mesmo.
  async test(id: number): Promise<{ sent: boolean; to: string; message_id?: string }> {
    const url = URLS.admin.accounts.evolution.test(id);
    const result = await sendServerRequest('POST', url);
    return result.data.data;
  },

  // Lista os V8 logins disponíveis para atrelar ao número (rota dedicada do admin).
  async listV8Logins(): Promise<V8Login[]> {
    const result = await sendServerRequest('GET', URLS.admin.accounts.v8.list);
    return result.data.data.v8s ?? [];
  },
};
